<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="login-bg-main-section register-main-section width-full float-l" id="login-main-hr">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="login-left-section float-l"> <!--left section-->
            <router-link v-bind:to="{ path:'/'}"> <img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </router-link>
        </div> <!--left section-->
        <div class="register-right-main-section width-full float-l"> <!--right section-->
            <form class="cmxform" @submit.prevent="emailVerify();" id="forgotPassword" name="form">

                <div class="register-form-main">
                    <h2> Forgot Password </h2>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                            <label v-if="isEmail == 'undefined'" for="uname">Dayforce Id / Email <span class="text-danger">*</span></label>
                            <label v-else-if="isEmail == true" for="uname">Email <span class="text-danger">*</span></label>
                            <label v-else for="uname">Dayforce Id <span class="text-danger">*</span></label>
                            <input id="username" type="text" placeholder="" name="uname" v-model="username">
                            <font class="text-danger">{{frontendErrors.username}}</font>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                            <font class="text-danger"> <label id="errorMsg" class="error text-danger"></label><br> </font>
                            <font class="text-danger"> <label id="successMsg" class="success text-success"></label><br> </font>
                        </div>

                        <div class="btm-login-section btm-register-section col-12 float-l">
                            <div class="btn-login-main float-l col-12 col-sm-6 col-md-6 col-lg-6 col-offset-0 col-sm-offset-3 col-md-offset-3 col-lg-offset-3">
                                <div class="row">  
                                    <button class="hvr-sweep-to-right-red" id="sendEmail">Submit</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div> <!--right section-->
    </div>
</template>

<script>
    import EventBus from './event-bus';
    import {loginUrl, configs} from '../config';
    import SessioMixin from '../mixins/sessionmixin';
    var self;
    import {HTTP} from '../http-common';
    //import Autocomplete from 'vuejs-auto-complete'
    import Vue from 'vue';
    export default {
        name: 'Login',
        props: [''],
        components: {},
        mixins: [SessioMixin],
        data() {
            return {
                isEmail: "undefined",
                username: '',
                frontendErrors: {
                    username: '',
                },
                backendErrors: [],
            }
        },
        mounted: function () {
            self = this;
            self.getBuildVersion();
            /* var loadCount = self.$route.query.load; */
            var tokenData = self.$route.query.token;
            var emailData = self.$route.query.email;
            var idetify = self.$route.query.idetify;
            /* if (typeof tokenData != 'undefined') {
                localStorage.removeItem("build_version");
                if (loadCount != 1) {
                    var redirectURL = "forgotpassword?token=" + tokenData + "?email=" + emailData + "?idetify=" + idetify + "?load=1";
                    self.$router.push(redirectURL);
                }
            } */
            $('#errorMsg,#successMsg').hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            $("#login-main-hr").height($(window).height());
            $("#username").on('keyup', function () {
                self.frontendErrors.username = '';
            });

            if (typeof tokenData != 'undefined') {
                var fields = {
                    tokenValue: tokenData,
                    username: emailData,
                };
                HTTP.post("checkuser", fields)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                localStorage.clear();
                                self.$router.push("/resetpassword/" + response.data.content + "?idetify=" + idetify);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            }
                        });
            }
        },
        watch: {
            username: function (username) {
                if (username == '') {
                    self.isEmail = 'undefined';
                } else {
                    self.isEmail = self.validEmail(username);
                }
            },
        },
        methods: {
            checkForm: function () {
                var checked = true;
                self.frontendErrors.username = "";
                if (!self.username) {
                    self.frontendErrors.username = 'Dayforce Id / Email is Required';
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            emailVerify() {
                self.checkForm();
                var flag = self.$route.query.identify;
                // console.log(flag);return false;
                if (self.checkForm()) {
                    $('#errorMsg').html('');
                    $('#successMsg').html('');
                    $('#errorMsg,#successMsg').hide();
                    $('#sendEmail').html('Submiting...');
                    $('#sendEmail').prop('disabled', true);
                    var fields = {
                        username: self.username,
                        flag: flag,
                        is_email: self.isEmail,
                    };
                    HTTP.post("checkuser", fields)
                            .then(function (response) {
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                if (response.data.status == "success") {
                                    $('#sendEmail').prop('disabled', true);
                                    $('#successMsg').show();
                                    $('#successMsg').html(response.data.message);
                                    //self.$router.push("/login");
                                    setTimeout(function () {
                                        $('#sendEmail').prop('disabled', false);
                                        self.$router.push("/login");
                                    }, 5000);
                                } else {
                                    $('#errorMsg').show();
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                            })
                            .catch(function (err) {
                                $('#sendEmail').html('Submit');
                                $('#sendEmail').prop('disabled', false);
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').show();
                                    $('#errorMsg').html(err.response.data.message);
                                }
                            });
                }

                //
            },
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/ForgotPassword.vue